import { roleAndPermissionSerializer } from '@/providers/serializers/role-and-permission/role-and-permission';
import { http } from '../http';

export class RolesAndPermissionAPI {

    private static INSTANCE = new RolesAndPermissionAPI();

    static get instance() {
        return this.INSTANCE;
    }

    private namespace: string = 'api/missioncontrol/v1';

    private adminNamespace: string = 'api/admin/v1';

    public fetchUsersList(tenantId: string) {
        const endpoint = `${this.namespace}/tenants/${tenantId}/users`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return roleAndPermissionSerializer.normalizeUserList(response.data);
        });
    }

    public fetchSettingsUserList() {
        const endpoint = `${this.adminNamespace}/admin/user/list`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return roleAndPermissionSerializer.normalizeSettingsUserList(response.data);
        });
    }

    public fetchRoleList() {
        const endpoint = `${this.adminNamespace}/admin/roles`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return roleAndPermissionSerializer.normalizeRoleList(response.data);
        });
    }

    public createUser(params: any) {
        const endpoint = `${this.adminNamespace}/admin/user/create`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, params).then((response) => {
            if (response && response.headers && response.headers.location) {
                return response.headers.location;
            }
            // return roleAndPermissionSerializer.normalizeRoleList(response.data);
        }).catch((error: any) => {
            const errorBlock: any = {};
            errorBlock.message = 'error';
            if (error && error.response) {
                errorBlock.displayMessage = error.response.data;
            }
            return errorBlock;
        });
    }

    public updateUser(params: any) {
        const endpoint = `${this.adminNamespace}/admin/user/update`;
        const headers = http.getTokenHeaders();
        return http.put(endpoint, headers, params).then((response) => {
            if (response && response.headers && response.headers.location) {
                return response.headers.location;
            }
        }).catch((error: any) => {
            const errorBlock: any = {};
            errorBlock.message = 'error';
            if (error && error.response) {
                errorBlock.displayMessage = error.response.data;
            }
            return errorBlock;
        });
    }

}
export const rolesAndPromissionAPI = RolesAndPermissionAPI.instance;
